export default "__VITE_ASSET__C$Nq2bGk__"